import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import IconBack from './icon_back.svg';
import s from './index.module.scss';

export const BackButton = ({ onClick, className }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={classnames(s.btn_back, className)}
    >
      <img src={IconBack} width={28} height={28} alt="back" />
      <span className="f-16 f-500">{t('buttons.back')}</span>
    </button>
  );
};
